import { useCallback } from "react";

import { API_BASE_URL } from "@/api/api.config";
import useRestMutation from "@/remoteState/useRestMutation";

const useQuestionFlagPost = () => {
  const createQuestionFlagPostRequest = useCallback((payload) => {
    const { activityId, message, questionId } = payload;

    const body = { message };

    const requestUrl = `${API_BASE_URL}/api/v3/quiz/${activityId}/question/${questionId}/flag/`;

    return new Request(requestUrl, {
      method: "POST",
      body: JSON.stringify(body),
      headers: { "Content-Type": "application/json" },
    });
  }, []);

  return useRestMutation(createQuestionFlagPostRequest);
};

export default useQuestionFlagPost;
